var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("EmailModal", {
    ref: "modal",
    on: {
      send: function($event) {
        return _vm.$emit("send", {
          ...$event,
          contact:
            _vm.contact === _vm.contactFromGroupUserExternal
              ? undefined
              : _vm.contact
        })
      }
    },
    scopedSlots: _vm._u([
      {
        key: "bodyTop",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("survey.group.emailModal.recipient")))
                ]),
                _vm._v(" "),
                _c("vSelect", {
                  attrs: {
                    options: _vm.contacts,
                    label: "label",
                    reduce: e => e.contact,
                    appendToBody: true,
                    "calculate-position": _vm.vSelectInModalWithPopper
                  },
                  model: {
                    value: _vm.contact,
                    callback: function($$v) {
                      _vm.contact = $$v
                    },
                    expression: "contact"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }